import './base/';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import 'slick-carousel';
import 'selectric';
import 'ez-plus';
import 'magnific-popup';
import "./btn-toggle";
import "./footer-accordion";
import "./mobile-navigation";
import "./sliders";
import "./lazyload";
import "./product";
import "./product-item";
import "./qty";
import "./accordion";
import "./custom-select";
import "./product-recommended";
import "./custom-scrollbar";
import "./btn-scroll";
import "./notify";
import "./select-relocate";
import "./popups";
import "./filter";
import "./mobile-inline-nav";
import "./subscribe";
import "./animated";
import "./search";
import "./load-more-items";
import "./nav-block-mobile";
import "./form-actions";
import "./store-locator";
import "./cart";
import "./ajax-forms";
import "./note";
import "./fixed-sections";
import "./global";
import "./personalize";
import "./checkout";

/*$(window).on('load', function() {
  $('#preview-bar-iframe').remove();
});*/

const winHref = window.location.href;

if (winHref.includes('site=dansk')) {
  $('html').addClass('html-dansk');
};



// WEBPACK FOOTER //
// ../assets/js/main.js